export const PRODUCT_TYPE_SIMPLE = 1;
export const PRODUCT_TYPE_COMPOSITE = 9;